module.exports = __webpack_public_path__ + "img/3a92b57dcf8242e289297863285aa723.b436aa79.jpg";